module.exports = __webpack_public_path__ + "static/img/vocational_banner.c1f6fc0f.png";